import script from "./ContactsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactsPage.vue?vue&type=script&setup=true&lang=js"

import "./ContactsPage.vue?vue&type=style&index=0&id=64cd1ccd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64cd1ccd"]])

export default __exports__